// extracted by mini-css-extract-plugin
export default {"List":"DesignImagesSection_List__IFhwp"};